// extracted by mini-css-extract-plugin
module.exports = {"container":"share_container__3ZNZR"};